// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 70,
  },
  subContainer: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(750)]: {
      width: '90%',
      marginTop: 15,
    },
  },
  title: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    width: 'fit-content',
    margin: '0 auto 20px auto',
  },
  subTitle: {
    margin: '10px 0',
    display: 'block',
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  },
  htmlContainer: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  }
});

export default styles;
